import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDownSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "#00427A",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.4281 8.0141L14.0141 6.6001L10.0151 10.6001L6.0141 6.6001L4.6001 8.0141L8.6001 12.0151L10.0151 13.4281L11.4281 12.0151L15.4281 8.0141Z"
	})]
});
const ForwardRef = forwardRef(SvgChevronDownSmall);
export { ForwardRef as ReactComponent };
